module.exports = __webpack_public_path__ + "img/3-service.6dc5936a.svg";